import controller from '../../../../Scripts/Controller.js';
import enquire from 'enquire.js';

function SidebarNav(container) {
    function init() {
        enquire.register('screen and (max-width:900px)', {
            match: function() {
                document.getElementById('AppendChildrenTo')?.appendChild(container);
            },
            unmatch: function() {
                document.getElementById('SidebarNavContainer')?.appendChild(container);
            }
        });
    }
    return {
        init: init
    }
}

controller.add('SidebarNav', SidebarNav);

export default SidebarNav;
